export const productListCn = [
  {
    "id": "1",
    "type": "30cm",
    "description": "标准30cm展架是常规展架最小桌面试听单元，可灵活运用于各种桌面式场景。",
    "specifications": {
      "dimensions": "长300*宽275*高345mm",
      "net_weight": "2.738KG",
      "gross_weight": "3.814KG",
      "package_size": "长450*宽375*高235mm",
      "materials": "塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "品牌专卖店陈列",
      "展会展示",
      "活动展示"
    ],
    "title": "30cm桌面展架",
    "tags": [
      "1SKU",
      "桌面展示"
    ],
    "desc": "标准展示架，适用于大多数产品型号",
    "compatibleProductDesc":'以下产品可在30cm桌面展架中展示'
  },
  {
    "id": "2",
    "type": "90cm",
    "description": "90cm标准展架是4SKU桌面式试听展架，适用于大空间桌面展示场景。",
    "specifications": {
      "dimensions": "长900*宽275*高345mm",
      "net_weight": "12.8KG",
      "gross_weight": "15.84KG",
      "package_size": "长975*宽500*高205mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "90cm桌面展架",
    "tags": [
      "4SKU",
      "桌面展示"
    ],
    "desc": "支持多产品展示的桌面展架系统",
    "compatibleProductDesc":'以下产品可在90cm桌面展架中展示'
  },
  {
    "id": "3",
    "type": "Shelf",
    "description": "双SKU货式展架，挂货与试听多功能兼容。",
    "specifications": {
      "dimensions": "长450*宽290*高1600mm",
      "net_weight": "23KG",
      "gross_weight": "28.5KG",
      "package_size": "长1128*宽538*高445mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示",
      "活动展示"
    ],
    "title": "shelf货架展架",
    "tags": [
      "1SKU",
      "带挂货"
    ],
    "desc": "适用于货架展示的展架",
     "compatibleProductDesc":'以下产品可在shelf货架展架中展示'
  },
  {
    "id": "4",
    "type": "Hook",
    "description": "单SKU挂式试听展架，适用于小空间墙面场景展示。",
    "specifications": {
      "dimensions": "长225*宽60*高300mm",
      "net_weight": "2.2KG",
      "gross_weight": "2.7KG",
      "package_size": "长294*宽370*高168mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "22.5cm挂式展架",
    "tags": [
      "1SKU",
      "墙面展示"
    ],
    "desc": "可安装在墙面上的标准挂式展架",
     "compatibleProductDesc":'以下产品可在22.5cm挂式展架中展示'
  },
  {
    "id": "5",
    "type": "Endcap",
    "description": "2SKU挂式试听展架，适用于大空间墙面场景。",
    "specifications": {
      "dimensions": "长450*宽60*高300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "长518*宽370*高168mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "45cm挂式展架",
    "tags": [
      "2SKU",
      "墙面展示"
    ],
    "desc": "支持多产品组合展示的挂式展架",
     "compatibleProductDesc":'以下产品可在45cm挂式展架中展示'
  },
  {
    "id": "6",
    "type": "",
    "description": "",
    "specifications": {
      "dimensions": "长450*宽60*高300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "长518*宽370*高168mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "水箱展架",
    "tags": [
      "2SKU",
      "墙面展示"
    ],
    "desc": "适用于特殊展示场景的水箱展架",
     "compatibleProductDesc":'以下产品可在水箱展架中展示'
  }
]

export const productListEn = [
  {
    "id": "1",
    "type": "30cm",
    "description": "The standard 30cm display is the smallest desktop audio unit among regular display stands, and can be flexibly used in various desktop scenarios.",
    "specifications": {
      "dimensions": "L300*W275*H345mm",
      "net_weight": "2.738KG",
      "gross_weight": "3.814KG",
      "package_size": "450*375*235mm",
      "materials": "Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Brand store display",
      "Exhibition display",
      "Event showcase"
    ],
    "title": "30cm Table Display",
    "tags": [
      "1SKU",
      "Desktop display"
    ],
    "desc": "Standard series display",                                        
    "compatibleProductDesc":"The following products can be displayed on the 30cm table display."
  },
  {
    "id": "2",
    "type": "90cm",
    "description": "The 90cm standard display is a 4SKU desktop audio-visual display, suitable for large-space desktop display scenarios.",
    "specifications": {
      "dimensions": "L900*W275*H345mm",
      "net_weight": "12.8KG",
      "gross_weight": "15.84KG",
      "package_size": "975*500*205mm",
      "materials": "Iron, Acrylic, Plastic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "90cm Table Display",
    "tags": [
      "4SKU",
      "Desktop display"
    ],
    "desc": "Desktop display stand system that supports multiple product displays",                                        
    "compatibleProductDesc":"The following products can be displayed on the 90cm table display."
  },
  {
    "id": "3",
    "type": "Shelf",
    "description": "The shelf is a 2SKU display, compatible with both hanging and audio-visual functions.",
    "specifications": {
      "dimensions": "L450*W290*H1600mm",
      "net_weight": "23KG",
      "gross_weight": "28.5KG",
      "package_size": "1128*538*445mm",
      "materials": "Iron ，Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display",
      "Event showcase"
    ],
    "title": "Shelf Display",
    "tags": [
      "1SKU",
      "With hanging goods"
    ],
    "desc": "Display system with shelves", 
    "compatibleProductDesc":"The following products can be displayed on the shelf display."
  },
  {
    "id": "4",
    "type": "Hook",
    "description": "Hook is a single-SKU hanging audio-visual display, suitable for wall-mounted displays in small spaces.",
    "specifications": {
      "dimensions": "L225*W60*H300mm",
      "net_weight": "2.2KG",
      "gross_weight": "2.7KG",
      "package_size": "294*370*168mm",
      "materials": "Iron,Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "22.5cm Hook Display",
    "tags": [
      "1SKU",
      "Wall display"
    ],
    "desc": "Standard wall-mountable display",
    "compatibleProductDesc":"The following products can be displayed on the 22.5cm hook display."
  },
  {
    "id": "5",
    "type": "Endcap",
    "description": "Endcap is a 2SKU wall-mounted audio display, suitable for large-space wall displays.",
    "specifications": {
      "dimensions": "L450*W60*H300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "518*370*168mm",
      "materials": "Iron,Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "45cm Hook Display",
    "tags": [
      "2SKU",
      "Wall display"
    ],
    "desc": "Endcap Display that supports displaying two products together",
    "compatibleProductDesc":"The following products can be displayed on the 45cm hook display."
  },
  {
    "id": "6",
    "type": "",
    "description": "",
    "specifications": {
      "dimensions": "L450*W60*H300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "518*370*168mm",
      "materials": "Iron,Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "Water Tank Display",
    "tags": [
      "2SKU",
      "Wall display"
    ],
    "desc": "Water tank display suitable for special scenarios",
    "compatibleProductDesc":"The following products can be displayed on the water tank display."
  }
]


export const productListOpenDots2Cn = [
  {
    "id": "1",
    "type": "30cm",
    "description": "标准30cm展架是常规展架最小桌面试听单元，可灵活运用于各种桌面式场景。",
    "specifications": {
      "dimensions": "长300*宽275*高345mm",
      "net_weight": "2.738KG",
      "gross_weight": "3.814KG",
      "package_size": "长450*宽375*高235mm",
      "materials": "塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "品牌专卖店陈列",
      "展会展示",
      "活动展示"
    ],
    "title": "30cm桌面展架",
    "tags": [
      "1SKU",
      "桌面展示"
    ],
    "desc": "标准展示架，适用于大多数产品型号",
    "compatibleProductDesc":'以下产品可在30cm桌面展架中展示'
  },
  {
    "id": "2",
    "type": "90cm",
    "description": "90cm标准展架是4SKU桌面式试听展架，适用于大空间桌面展示场景。",
    "specifications": {
      "dimensions": "长900*宽275*高345mm",
      "net_weight": "12.8KG",
      "gross_weight": "15.84KG",
      "package_size": "长975*宽500*高205mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "90cm桌面展架",
    "tags": [
      "4SKU",
      "桌面展示"
    ],
    "desc": "支持多产品展示的桌面展架系统",
    "compatibleProductDesc":'以下产品可在90cm桌面展架中展示'
  },
  {
    "id": "3",
    "type": "Shelf",
    "description": "双SKU货式展架，挂货与试听多功能兼容。",
    "specifications": {
      "dimensions": "长450*宽290*高1600mm",
      "net_weight": "23KG",
      "gross_weight": "28.5KG",
      "package_size": "长1128*宽538*高445mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示",
      "活动展示"
    ],
    "title": "shelf货架展架",
    "tags": [
      "1SKU",
      "带挂货"
    ],
    "desc": "适用于货架展示的展架",
     "compatibleProductDesc":'以下产品可在shelf货架展架中展示'
  },
  {
    "id": "4",
    "type": "Hook",
    "description": "单SKU挂式试听展架，适用于小空间墙面场景展示。",
    "specifications": {
      "dimensions": "长225*宽60*高300mm",
      "net_weight": "2.2KG",
      "gross_weight": "2.7KG",
      "package_size": "长294*宽370*高168mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "挂式展架",
    "tags": [
      "1SKU",
      "墙面展示"
    ],
    "desc": "可安装在墙面上的标准挂式展架",
     "compatibleProductDesc":'以下产品可在22.5cm挂式展架中展示'
  },
  {
    "id": "5",
    "type": "Endcap",
    "description": "2SKU挂式试听展架，适用于大空间墙面场景。",
    "specifications": {
      "dimensions": "长450*宽60*高300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "长518*宽370*高168mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "OpenDots Air展架",
    "tags": [
      "2SKU",
      "墙面展示"
    ],
    "desc": "支持多产品组合展示的挂式展架",
     "compatibleProductDesc":'以下产品可在45cm挂式展架中展示'
  },
  {
    "id": "6",
    "type": "",
    "description": "",
    "specifications": {
      "dimensions": "长450*宽60*高300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "长518*宽370*高168mm",
      "materials": "铁、塑料、亚克力"
    },
    "usage_scenarios": [
      "零售店铺产品展示",
      "展会展示"
    ],
    "title": "水箱展架",
    "tags": [
      "2SKU",
      "墙面展示"
    ],
    "desc": "适用于特殊展示场景的水箱展架",
     "compatibleProductDesc":'以下产品可在水箱展架中展示'
  }
]

export const productListOpenDots2En = [
  {
    "id": "1",
    "type": "30cm",
    "description": "The standard 30cm display is the smallest desktop audio unit among regular display stands, and can be flexibly used in various desktop scenarios.",
    "specifications": {
      "dimensions": "L300*W275*H345mm",
      "net_weight": "2.738KG",
      "gross_weight": "3.814KG",
      "package_size": "450*375*235mm",
      "materials": "Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Brand store display",
      "Exhibition display",
      "Event showcase"
    ],
    "title": "30cm Table Display",
    "tags": [
      "1SKU",
      "Desktop display"
    ],
    "desc": "Standard series display",                                        
    "compatibleProductDesc":"The following products can be displayed on the 30cm table display."
  },
  {
    "id": "2",
    "type": "90cm",
    "description": "The 90cm standard display is a 4SKU desktop audio-visual display, suitable for large-space desktop display scenarios.",
    "specifications": {
      "dimensions": "L900*W275*H345mm",
      "net_weight": "12.8KG",
      "gross_weight": "15.84KG",
      "package_size": "975*500*205mm",
      "materials": "Iron, Acrylic, Plastic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "90cm Table Display",
    "tags": [
      "4SKU",
      "Desktop display"
    ],
    "desc": "Desktop display stand system that supports multiple product displays",                                        
    "compatibleProductDesc":"The following products can be displayed on the 90cm table display."
  },
  {
    "id": "3",
    "type": "Shelf",
    "description": "The shelf is a 2SKU display, compatible with both hanging and audio-visual functions.",
    "specifications": {
      "dimensions": "L450*W290*H1600mm",
      "net_weight": "23KG",
      "gross_weight": "28.5KG",
      "package_size": "1128*538*445mm",
      "materials": "Iron ，Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display",
      "Event showcase"
    ],
    "title": "Shelf Display",
    "tags": [
      "1SKU",
      "With hanging goods"
    ],
    "desc": "Display system with shelves", 
    "compatibleProductDesc":"The following products can be displayed on the shelf display."
  },
  {
    "id": "4",
    "type": "Hook",
    "description": "Hook is a single-SKU hanging audio-visual display, suitable for wall-mounted displays in small spaces.",
    "specifications": {
      "dimensions": "L225*W60*H300mm",
      "net_weight": "2.2KG",
      "gross_weight": "2.7KG",
      "package_size": "294*370*168mm",
      "materials": "Iron,Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "Hook Display",
    "tags": [
      "1SKU",
      "Wall display"
    ],
    "desc": "Standard wall-mountable display",
    "compatibleProductDesc":"The following products can be displayed on the 22.5cm hook display."
  },
  {
    "id": "5",
    "type": "Endcap",
    "description": "Endcap is a 2SKU wall-mounted audio display, suitable for large-space wall displays.",
    "specifications": {
      "dimensions": "L450*W60*H300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "518*370*168mm",
      "materials": "Iron,Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "OpenDots Air Display",
    "tags": [
      "2SKU",
      "Wall display"
    ],
    "desc": "Endcap Display that supports displaying two products together",
    "compatibleProductDesc":"The following products can be displayed on the 45cm hook display."
  },
  {
    "id": "6",
    "type": "",
    "description": "",
    "specifications": {
      "dimensions": "L450*W60*H300mm",
      "net_weight": "3.75KG",
      "gross_weight": "4.5KG",
      "package_size": "518*370*168mm",
      "materials": "Iron,Plastic, Acrylic"
    },
    "usage_scenarios": [
      "Retail store product display",
      "Exhibition display"
    ],
    "title": "Water Tank Display",
    "tags": [
      "2SKU",
      "Wall display"
    ],
    "desc": "Water tank display suitable for special scenarios",
    "compatibleProductDesc":"The following products can be displayed on the water tank display."
  }
]